<!--
  2022-06-10 created by HHY
-->
<template>
  <el-card class="notice">
    <el-carousel indicator-position="none" height="100px" class="elcarlousel" arrow="never" direction="vertical" :interval="5000">
      <el-carousel-item v-for="(item, index) in this.nameArrays" :key="index" class="notice_item">
        <div v-html="item" class="notice-content"></div>
      </el-carousel-item>
   </el-carousel>
 </el-card>
</template>

<script>
export default {
  name: 'DWCarousel',
  data () {
    return {
      charArray1: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'],
      charArray2: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'],
      depositAmountArray: ['100', '300', '500', '1,000', '3,000', '5,000', '10,000', '20,000', '50,000'],
      widthdrawAmountArray: ['500', '1,000', '2,000', '5,000', '10,000', '30,000', '50,000'],
      nameArrays: [],
      deposited: this.$t('lang.account.deposited'),
      withdrew: this.$t('lang.account.withdrew')
    }
  },
  mounted () {
    setInterval(this.getNamesArr(20, 4), 30000) // 生成10个元素的数组，每个元素为4个人得名字 1分钟内重新换一批数据
  },
  watch: {
    '$store.state.locale': function () {
      this.deposited = this.$t('lang.account.deposited')
      this.withdrew = this.$t('lang.account.withdrew')
    }
  },
  methods: {
    getNamesArr (n, m) { // 生成n个数组，每个数组里m个用户充值或取钱信息
      this.nameArrays = []
      for (var i = 0; i < n; i++) {
        const arr = this.getANamesArr(m)
        this.nameArrays.push(arr)
      }
    },
    getANamesArr (n) { // 生成n个用户的信息，包括用户充值或取钱信息
      var name = ''
      for (var i = 0; i < n; i++) {
        if (i === 0) {
          name += this.getOneName() + this.getDepositOrWithdraw()
        } else {
          name += '<br/>' + this.getOneName() + this.getDepositOrWithdraw()
        }
      }
      return name
    },
    getDepositOrWithdraw () { // 80%的概率是deposit,20%的概率是withdraw
      var res = ''
      var num = Math.floor(Math.random() * (1 - 100) + 100)
      const currency = this.$t('lang.account.currencyType')
      if (num >= 1 && num <= 80) {
        res = ' ' + this.deposited + ' ' + currency + this.getWords(this.depositAmountArray, 1)
      } else {
        res = ' ' + this.withdrew + ' ' + currency + this.getWords(this.widthdrawAmountArray, 1)
      }
      return res
    },
    getOneName () { // 生成一位用户的名字，长度4~12位，中间用星号代替
      const n = Math.round(Math.random() + 1)
      const m = this.betweenRandom(4, 12)
      const start = this.getWords(this.charArray1, n)
      const end = this.getWords(this.charArray2, 1)
      const k = m - n - 1
      const stars = this.randomStar(k)
      const result = start + stars + end
      return result
    },
    getWords (arr, n) { // 从数组arr中随机抽取n个元素，将这n个元素组成字符串
      var res = ''
      for (var i = 0; i < n; i++) {
        var id = Math.floor(Math.random() * arr.length)
        res += arr[id]
      }
      return res
    },
    betweenRandom (min, max) { // 在两个数字之间取随机数
      return min + Math.floor(Math.random() * (max - min + 1))
    },
    randomStar (n) { // 生成n个连续的星号
      var res = ''
      for (var i = 0; i < n; i++) {
        res += '*'
      }
      return res
    }
  }
}
</script>

<style lang="less" scoped>
.notice{
    z-index: 2;
    padding: 0;
  }
  .notice /deep/ .el-card__body{
    padding: 0;
  }
  .notice_item{
    height: 100px;
    display: flex;
    flex-direction: row;
    align-items: center;
    color: #F6D9AA;
  }
  .notice-content{
    padding:5px;
    line-height: 20px;
    font-size: 13px;
    text-align: center;
    width: 100%;
  }
  .elcarlousel{
    border: 1px solid #F6D9AA;
    background-color: #161616;
    border-radius: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/GatewayWithdrawCarousel/index.vue